export const translations = {
  ru: {
    contactTitle: "Свяжитесь с нами",
    addressLabel: "Адрес:",
    addressValue: "г. Бишкек, ул. Шота Руставели 42а",
    phoneLabel: "Телефон:",
    phoneValue: "+996 (880) 14-70-14",
    emailLabel: "Email:",
    emailValue: "unipaytechnology@gmail.com",
    workTimeLabel: "Время работы:",
    workTimeValue: "Пн–Пт: 09:00–18:00",
  },
  kg: {
    contactTitle: "Биз менен байланыш",
    addressLabel: "Дарек:",
    addressValue: "Бишкек шаары, Шота Руставели 42а",
    phoneLabel: "Телефон:",
    phoneValue: "+996 (880) 14-70-14",
    emailLabel: "Электрондук почта:",
    emailValue: "unipaytechnology@gmail.com",
    workTimeLabel: "Иштөө убакыты:",
    workTimeValue: "Дүйш–Жума: 09:00–18:00",
  },
};
